<div class="m-6">
  <h2>{{ 'General.SelectLanguage' | translate }}</h2>
  <br />
  <button
    class="rounded border py-4 px-6 min-w-[5rem] mr-2 bg-white hover:bg-neutral-200"
    [class.active]="translate.currentLang === 'en'"
    (click)="this.translate.use('en')"
  >
    en
  </button>
  <button
    class="rounded border py-4 px-6 min-w-[5rem] bg-white hover:bg-neutral-200"
    [class.active]="translate.currentLang === 'de'"
    (click)="this.translate.use('de')"
  >
    de
  </button>

  <br />
  <br />

  <label>browser-Language: {{ this.browserLang }}</label>
  <br />
  <label>selected-Language: {{ this.translate.currentLang }}</label>
  <br />
  <br />
  <hr />
  <br />

  <h2>{{ 'Activity.create' | translate }}</h2>
  <br />
</div>
